import axios from 'axios'

export default {
    getRule(){
        return axios.get('/rule')
            .then(response => {
                return response.data
            })
    },
    getRuleDataSource(params){
        return axios.get('/rule/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getRulebyID(id){
        return axios.get('/rule/' + id)
            .then(response => {
                return response.data
            })
    },   
    getRulebyTarget(id){
        return axios.get('/rule/target' )
            .then(response => {
                return response.data
            })
    },  
    createRule(formdata){
        return axios.post('/rule', formdata)
            .then(response => {
                return response.data
            })
    },
    updateRule(id,formdata){
        return axios.put('/rule/' + id, formdata)
            .then(response => {
                return response.data
            })
    },
    destroyRule(id){
        return axios.delete('/rule/' + id)
            .then(response => {
                return response.data
            })
    }, 
    
}